module.exports = __webpack_public_path__ + "static/media/img7.0178e797.jpg";